import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import {
  AvailableLanguageCodesEnum,
  LandlordUser,
  Language,
  PropertySearcherUser
} from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { LangPickerComponent } from '../../molecules/lang-picker/lang-picker.component';
import { LogoComponent } from '../logo/logo.component';

@Component({
  selector: 'app-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrls: ['./header-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LogoComponent,
    LangPickerComponent,
    FormsModule,
    SvgIconComponent,
    TranslatePipe,
    ImmomioButtonComponent
  ]
})
export class HeaderV2Component {
  readonly user = input<LandlordUser | PropertySearcherUser>(undefined);
  readonly tenantInInternalPool = input<boolean>(undefined);
  readonly showSearchIcon = input<boolean>(undefined);
  readonly showLanguagePicker = input(false);
  readonly availableLanguages = input<Language[]>(undefined);
  readonly defaultLanguageCode = input<AvailableLanguageCodesEnum>(undefined);
  readonly currentLanguageCode = input<AvailableLanguageCodesEnum>(undefined);

  readonly openSearch = output();
  readonly hasPermission = output();
  readonly languageChange = output<AvailableLanguageCodesEnum>();
  readonly logout = output();
  readonly profileSettingsToggle = output();

  public onLanguageChange(value: AvailableLanguageCodesEnum) {
    this.languageChange.emit(value);
  }
}
